<template>
  <div class="">
    <div class="cursor-pointer flex justify-between py-1 justify-center"
         @click="toggle">
      <slot name="title"></slot>
      <ChevronDownIcon v-if="!isOpen" class="text-blue-500 w-6 h-6"/>
      <ChevronUpIcon v-else class="text-blue-500 w-6 h-6"/>
    </div>

    <div v-if="isOpen" class="py-2">
      <slot name="content"></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    opened: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      isOpen: this.opened
    }
  },
  watch: {
    opened(value) {
      this.isOpen = value
    }
  },
  methods: {
    toggle() {
      if(this.isOpen) {
        this.$emit('close')
        this.isOpen = false
      } else {
        this.$emit('open')
        this.isOpen = true
      }
    }
  }
}
</script>